import React, { useMemo } from "react";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";

import styles from "./MovePartModal.module.scss";
import Button from "@components/global/new/Button/Button";
import Title from "@components/global/new/Title/Title";

interface IMovePartModal extends CommonModalPropsI {
  readonly type: "in_use" | "stock" | "discarded";
}

function MovePartModal(props: IMovePartModal) {
  const title = useMemo(
    () => props.formatMessage({ id: `modal.move.title.${props.type}` }),
    [props.type]
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Title className={styles.title}>{title}</Title>
      </div>

      {props.type === "in_use" && (
        <div className={styles.miner_selector}>selector</div>
      )}

      <div className={styles.btns}>
        <Button className={styles.btn} red>
          {props.formatMessage({ id: "modal.confirm.btn.no" })}
        </Button>
        <Button className={styles.btn}>
          {props.formatMessage({ id: "modal.move.btn" })}
        </Button>
      </div>
    </div>
  );
}
export default WithModal(MODALS_ENUM.MOVE_PART_MODAL, MovePartModal, {
  style: { padding: 0 },
});
